import { FC, useState, forwardRef } from 'react';

import { FaEye, FaEyeSlash } from 'react-icons/fa';

import styles from './Iqloud_PasswordInput.module.scss';

type Props = any;

const PasswordInput: FC<Props> = (props: Props) => {
  const [show, setShow] = useState(false);

  const { children, className, ...inputProps } = props;
  return (
    <div className={`${styles.passwordInput} ${className}`}>
      <input className={`${styles.inputText}`} type={show ? 'text' : 'password'} {...inputProps} />
      <span className={styles.eye} onClick={() => setShow(!show)}>
        {show ? <FaEye /> : <FaEyeSlash />}
      </span>
    </div>
  );
};

export const RefPasswordInput = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const [show, setShow] = useState(false);

  const { children, className, ...inputProps } = props;
  return (
    <div className={`${styles.passwordInput} ${className}`}>
      <input
        maxLength={100}
        className={`${styles.inputText}`}
        type={show ? 'text' : 'password'}
        ref={ref}
        {...inputProps}
      />
      <span className={styles.eye} onClick={() => setShow(!show)}>
        {show ? <FaEye /> : <FaEyeSlash />}
      </span>
    </div>
  );
});
RefPasswordInput.displayName = 'RefPasswordInput';

export default PasswordInput;
